import React, { useEffect, useState } from "react";
import useInputKeys from "hooks/useInputKeys";
import BackButton from "assets/images/backButton.png";
import Setting from "./Setting";
import Theme from "./Theme";
import Language from "./Language";
import { useTranslation } from "react-i18next";
import "./index.scss";
import Profile from "./profile";
import { useGetMyProfile } from "hooks/user";

const Settings = () => {
  const { direction } = useInputKeys();
  const [activeTab, setActiveTab] = useState("setting");
  const { t } = useTranslation();
  const { mutate: getMyProfile } = useGetMyProfile();
  const { setUserInfo } = useInputKeys();

  useEffect(() => {
    getMyProfile(
      {},
      {
        onSuccess: ({ status, user }) => {
          if (status === "OK" && user) {
            setUserInfo(user);
          }
        },
        onError: (e) => {
          console.log(e);
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="setting-wrapper">
      <div className="setting-nav">
        {activeTab !== "setting" && (
          <div className="icon" onClick={() => setActiveTab("setting")}>
            <img
              src={BackButton}
              alt="BackButton"
              style={{
                transform: `rotate(${direction === "rtl" ? 180 : 0}deg)`,
              }}
            />
          </div>
        )}
        <div className="title">{t(activeTab)}</div>
      </div>
      <div className="container-body">
        {activeTab === "setting" ? (
          <Setting setTab={setActiveTab} />
        ) : activeTab === "language" ? (
          <Language />
        ) : activeTab === "profile" ? (
          <Profile />
        ) : (
          <Theme />
        )}
      </div>
    </div>
  );
};

export default Settings;
